<template>
  <v-container fluid class="new-appraisal">
    <div class="new-appraisal-content" v-if="steps">
      <v-stepper v-model="e1">
        <v-stepper-header class="headerFix">
          <template>
            <v-stepper-step
              v-for="n in steps"
              :key="`${n.step}-step`"
              :complete="e1 > n.step"
              :step="n.step"
              editable
              class="w-100"
            >
              <span class="ml-2">{{ n.label }}</span>
              <v-divider v-if="n !== steps" :key="n.step"></v-divider>
            </v-stepper-step>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content
            v-for="n in steps"
            :key="`${n.step}-content`"
            :step="n.step"
          >
            <div class="content-step1" v-if="n.step == 1">
              <v-text-field
                v-model="step1.name"
                placeholder="Propietario"
                type="text"
                disabled
              ></v-text-field>
              <v-text-field
                v-model="step1.phone"
                placeholder="Telefono"
                type="number"
                disabled
              ></v-text-field>
              <v-text-field
                v-model="step1.interesado"
                placeholder="V.Interesado"
                type="text"
                disabled
              ></v-text-field>
              <v-text-field
                v-model="step1.entrega"
                placeholder="Entrega inmediata"
                type="text"
                disabled
              ></v-text-field>
              <v-text-field
                v-model="step1.brand"
                placeholder="Marca"
                type="text"
                disabled
              ></v-text-field>
              <h3>Datos del vehículo</h3>

              <v-text-field
                v-model="step1.model"
                placeholder="Modelo"
                type="text"
                disabled
              ></v-text-field>

              <v-text-field
                v-model="step1.plate"
                placeholder="Matrícula"
                type="text"
                disabled
              ></v-text-field>

              <v-text-field
                v-model="step1.color"
                placeholder="Color"
                type="text"
                disabled
              ></v-text-field>

              <v-text-field
                v-model="step1.kilometers"
                placeholder="Kilómetros"
                type="text"
                disabled
              ></v-text-field>

              <v-text-field
                v-model="step1.engine"
                placeholder="Motor"
                type="text"
                disabled
              ></v-text-field>

              <v-text-field
                v-model="step1.year"
                placeholder="Año"
                type="text"
                disabled
              ></v-text-field>

              <v-text-field
                v-model="step1.itv"
                placeholder="ITV"
                type="text"
                disabled
              ></v-text-field>

              <v-text-field
                v-model="step1.insurance"
                placeholder="Seguro"
                type="text"
                disabled
              ></v-text-field>

              <v-textarea
                v-model="step1.notes"
                label="Observaciones"
                disabled
              ></v-textarea>

              <h3>Documentación</h3>
              <h3 v-if="docSelected.length <= 0">
                No hay documentación de este vehículo
              </h3>
              <div v-else class="d-flex justify-center flex-wrap">
                <span v-for="img in docSelected" :key="img.id">
                  <img
                    :src="img.doc"
                    width="350"
                    height="350"
                    style="object-fit: cover; width: 100%; height: auto;"
                    @click="
                      openGallery = true;
                      imagesGallery = img.doc;
                    "
                  />
                </span>
              </div>
            </div>

            <div class="content-step2" v-if="n.step == 2">
              <v-tabs v-model="tab" color="primary" grow>
                <v-tab v-for="item in tabItem" :key="item">
                  {{ item }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item v-for="item in tabItem" :key="item">
                  <v-card flat>
                    <v-row class="manual mt-5" v-if="item == 'Manual'">
                      <v-col cols="12">
                        <div class="mb-5">
                          <h3>Mecánica y Electricidad</h3>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th>
                                  Bien
                                </th>
                                <th>
                                  Regular
                                </th>
                                <th>
                                  Mal
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="MOTOR"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_engine"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_engine"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_engine"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="EMBRAGUE"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_clutch"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_clutch"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_clutch"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="CAJA DE CAMBIOS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_gearbox"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_gearbox"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_gearbox"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="DIRECCIÓN"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_direction"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_direction"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.mechanics_direction"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td colspan="4">
                                  <v-textarea
                                    placeholder="VARIOS"
                                    v-model="step2.mechanics_other"
                                    disabled
                                  ></v-textarea>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>

                        <div class="mt-5">
                          <h3>Interior</h3>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th>
                                  Bien
                                </th>
                                <th>
                                  Regular
                                </th>
                                <th>
                                  Mal
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="VOLANTE"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_steering_wheel"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_steering_wheel"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_steering_wheel"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="ASIENTOS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_seating"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_seating"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_seating"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="TECHO"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_roof"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_roof"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_roof"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="ESTADO GENERAL"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_general_status"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_general_status"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.interior_general_status"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>
                      </v-col>
                      <v-col cols="2" class="d-flex justify-center">
                        <v-divider vertical></v-divider>
                      </v-col>
                      <v-col cols="12">
                        <div class="mb-5">
                          <h3>Exterior</h3>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th>
                                  Bien
                                </th>
                                <th>
                                  Regular
                                </th>
                                <th>
                                  Mal
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="LATERAL D"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_lateral_right"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_lateral_right"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_lateral_right"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="LATERAL I"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_lateral_left"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_lateral_left"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_lateral_left"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="P.DELANTERA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_front"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_front"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_front"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="P.TRASERA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_back"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_back"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_back"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="PINTURA"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_general_paint"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_general_paint"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_general_paint"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="LUNAS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_windows"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_windows"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.exterior_windows"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>

                        <div class="mt-5">
                          <h3>Neumáticos</h3>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <th></th>
                                <th>
                                  Bien
                                </th>
                                <th>
                                  Regular
                                </th>
                                <th>
                                  Mal
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <v-text-field
                                    value="DELANTEROS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_front"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_front"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_front"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="TRASEROS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_back"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_back"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_back"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="LLANTAS"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_llantas"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_llantas"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_llantas"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>

                              <tr>
                                <td>
                                  <v-text-field
                                    value="ESTADO GENERAL"
                                    type="text"
                                    disabled
                                  ></v-text-field>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_general_status"
                                    color="green"
                                    value="BIEN"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_general_status"
                                    color="yellow"
                                    value="REGULAR"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                                <td>
                                  <v-checkbox
                                    v-model="step2.tires_general_status"
                                    color="red"
                                    value="MAL"
                                    hide-details
                                    disabled
                                  ></v-checkbox>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>

                        <div class="mt-5">
                          <h3>Imágenes</h3>
                        </div>

                        <div class="mt-5">
                          <h3>Galería</h3>
                          <h3 v-if="imagesSelected.length <= 0">
                            No hay imágenes de este vehículo
                          </h3>
                          <div v-else class="d-flex justify-center flex-wrap">
                            <span v-for="img in imagesSelected" :key="img.id">
                              <img
                                :src="img.image"
                                width="350"
                                height="350"
                                style="object-fit: cover; width: 100%; height: auto;"
                                @click="
                                  openGallery = true;
                                  imagesGallery = img.image;
                                "
                              />
                            </span>
                          </div>
                        </div>

                        <div class="mt-5">
                          <h3>Partes seguro</h3>
                          <v-checkbox
                            type="checkbox"
                            label="Parte frontal"
                            v-model="step2.insurance_part_front"
                          >
                          </v-checkbox>
                          <v-checkbox
                            type="checkbox"
                            label="Parte trasero"
                            v-model="step2.insurance_part_back"
                          >
                          </v-checkbox>
                          <v-checkbox
                            type="checkbox"
                            label="Parte lateral derecho"
                            v-model="step2.insurance_part_llantas"
                          >
                          </v-checkbox>
                          <v-checkbox
                            type="checkbox"
                            label="Parte lateral izquierdo"
                            v-model="step2.insurance_part_general_status"
                          >
                          </v-checkbox>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </div>
            <div class="content-step3" v-if="n.step == 3">
              <v-text-field
                v-model="step3.appraised_value"
                placeholder="Precio"
                type="number"
                :disabled="userRol != 'Validator' ? true : false"
              ></v-text-field>
              <v-btn
                color="success"
                @click="changePrice()"
                v-if="userRol == 'Validator'"
              >
                CAMBIAR PRECIO
              </v-btn>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      :color="snackbarColor"
    >
      {{ snackbarText }}
    </v-snackbar>
    <!-- Galería de img -->
    <v-dialog
      v-model="openGallery"
      width="1200"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="openGallery = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div>
          <img :src="imagesGallery" style="object-fit: cover; width: 100%;" />
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { getMethodToken, postMethodToken } from "@/api-consume/api-calls";
import store from "@/store/index";
export default {
  props: ["dataSelected"],
  data() {
    return {
      userRol: store.state.userLogged.roles[0].rol,
      snackbar: false,
      snackbarText: "",
      snackbarTimeout: 3000,
      snackbarColor: "",
      tab: null,
      tabItem: ["Manual"],
      openGallery: false,
      imagesGallery: [],
      e1: 1,
      step1: {
        name: "",
        phone: "",
        interesado: "",
        commercial_user_id: store.state.userLogged.user_id,
        entrega: "",
        brand: "",
        model: "",
        plate: "",
        color: "",
        kilometers: "",
        engine: "",
        year: "",
        itv: "",
        insurance: "",
        notes: "",
      },
      step2: {
        //Mecánica y electricidad
        mechanics_engine: "",
        mechanics_clutch: "",
        mechanics_gearbox: "",
        mechanics_direction: "",
        mechanics_other: "",
        //Interior
        interior_steering_wheel: "",
        interior_seating: "",
        interior_roof: "",
        interior_general_status: "",
        //Exterior
        exterior_lateral_right: "",
        exterior_lateral_left: "",
        exterior_front: "",
        exterior_back: "",
        exterior_general_paint: "",
        exterior_windows: "",
        //Neumáticos
        tires_front: "",
        tires_back: "",
        tires_llantas: "",
        tires_general_status: "",
        //Partes
        insurance_part_front: false,
        insurance_part_back: false,
        insurance_part_llantas: false,
        insurance_part_general_status: false
      },
      step3: {
        appraised_value: "",
        appraiser_user_id: "",
      },
      step4: {
        appraised_value: "",
        validator_user_id: "",
      },
      validate: false,
      images: [],
      imagesSelected: [],
      documentation: [],
      docSelected: [],
      responseId: this.dataSelected.id,
    };
  },

  computed: {
    steps() {
      return [
        { label: "Datos de cliente", step: 1 },
        { label: "Datos de vehículo", step: 2 },
        { label: "Precio del vehículo", step: 3 },
      ];
    },
  },

  async created() {
    Object.keys(this.dataSelected).forEach((key) => {
      if (key in this.step1) {
        this.step1[key] = this.dataSelected[key];
      }
      if (key in this.step2) {
        this.step2[key] = this.dataSelected[key];
      }
      if (key in this.step3) {
        this.step3[key] = this.dataSelected[key];
      }
      if (key in this.step4) {
        this.step4[key] = this.dataSelected[key];
      }
    });

    await this.getDoc();
    await this.getImages();
  },

  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
  },

  methods: {
    async getDoc() {
      const response = await getMethodToken(
        "/api/appraisals/docs/" + this.responseId
      );
      console.log("GET LISTA DOCUMENTACION: ", response);

      if (response.status == 200) {
        this.docSelected = response.data.payload.docs;
        this.spinn = false;
      } else {
        this.snackbar = true;
        this.snackbarText = response.data.message;
        this.snackbarColor = "red";
        this.spinn = false;
      }
    },
    async getImages() {
      const response = await getMethodToken(
        "/api/appraisals/images/" + this.responseId
      );
      console.log("LISTA IMAGENES: ", response);

      if (response.status == 200) {
        this.imagesSelected = response.data.payload.images;
        this.spinn = false;
      } else {
        this.snackbar = true;
        this.snackbarText = response.data.message;
        this.snackbarColor = "red";
        this.spinn = false;
      }
    },
    async changePrice() {
      let options = this.step3;
      options.id = this.responseId;
      options.validator_user_id = store.state.userLogged.user_id;
      options.confirmed = 1;

      const response = await postMethodToken("/api/appraisal/create", options);
      console.log("CREAR TASACIÓN: ", response);

      if (response.status == 200) {
        this.responseId = response.data.payload.appraisal.id;
        this.snackbar = true;
        this.snackbarText = "Precio cambiado correctamente.";
        this.snackbarColor = "green";
      } else {
        this.snackbar = true;
        this.snackbarText = "Error al cambiar el precio.";
        this.snackbarColor = "red";
      }
    },
  },
};
</script>

<style>
@media only screen and (max-width: 600px) {
  .headerFix {
    height: auto !important;
  }
  .w-100 {
    width: 100%;
  }
}
</style>
